import { render, staticRenderFns } from "./OrderPdfView.vue?vue&type=template&id=61c59780&scoped=true&"
import script from "./OrderPdfView.vue?vue&type=script&lang=js&"
export * from "./OrderPdfView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c59780",
  null
  
)

export default component.exports